import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    IonicModule,
    PipesModule
  ],
  exports: [
    CommonModule,
    IonicModule,
    PipesModule
  ]
})
export class ShareableModule { }
